export const RECENTS_FOLDER_ID = 'recents'; // This is lowercase because its used in params too
export const DRAFTS_FOLDER_ID = 'drafts'; // This is lowercase because its used in params too
export const INTERVIEWS_FOLDER_ID = 'interviews'; // This is lowercase because its used in params too
export const DEPENDENCIES_FILE_ID = 'dependencies';

export const NEW_TEAM_FTE = 'NEW_TEAM_FTE';
